import { EPersona } from '@sharedInterfaces/EPersona';
import { ELinks } from '@sharedInterfaces/globalEnums';
import MvpDashboardPage from '@src/App/Pages/DashboardPage/MvpDashboardPage';
import DocumentationPage from '@src/App/Pages/Documentation/DocumentationPage';
import RestApiDocuPage from '@src/App/Pages/Documentation/RestApiDocuPage/RestApiDocuPage';
import SalesPage from '@src/App/Pages/EntityPages/SalesPage/SalesPage';
import NotAllowed from '@src/App/Pages/ErrorPages/NotAllowed';
import NotFound from '@src/App/Pages/ErrorPages/NotFound';
import EmailSettingsPage from '@src/App/Pages/email/EmailSettingsPage';
import EmailUnsubscribePage from '@src/App/Pages/email/EmailUnsubscribePage';
import LoggedInPage from '@src/App/Pages/LoggedInPage/LoggedInPage';
import LoginPage from '@src/App/Pages/LoginPage';
import ProfileSettings, { EProfileSettingsTabs } from '@src/App/Pages/MyProfilePage/ProfileSettings';
import PeopleOrgPage from '@src/App/Pages/PeopleOrgPage/PeopleOrgPage';
import SettingsPage, { ESettingsTabs } from '@src/App/Pages/SettingsPage/SettingsPage';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import MvpCompanyLandingPage from './Components/_UnderConstruction/Company/MvpCompanyLandingPage';
import Datenschutz from './Components/_UnderConstruction/Datenschutz';
import Impressum from './Components/_UnderConstruction/Impressum';
import Kontakt from './Components/_UnderConstruction/Kontakt';
import MvpEmployeePage from './Components/_UnderConstruction/MvpEmployeePage/MvpEmployeePage';
import MyTeamLandingPage from './Components/_UnderConstruction/MyTeam/MyTeamLandingPage';
import OnboardingPage from './Components/_UnderConstruction/Onboarding/OnboardingPage';
import LandingMvpOpportunity from './Components/_UnderConstruction/Opportunities/LandingMvpOpportunity';
import MvpOpportunitiesPage from './Components/_UnderConstruction/Opportunities/MvpOpportunitiesPage';
import MvpOpportunityPage from './Components/_UnderConstruction/Opportunities/MvpOpportunityPage';
import { EMessageTabs, MessagesPage } from './Components/_UnderConstruction/Pages/Messages/MessagesPage';
import MyTeamPage from './Components/_UnderConstruction/Pages/MyTeamPage/MyTeamPage';
import CompanyRegistrationPage from './Pages/CompanyRegistrationPage/CompanyRegistrationPage';
import BusinessesPage from './Pages/EntityPages/Businesses/BusinessesPage/BusinessesPage';
import BusinessPage from './Pages/EntityPages/Businesses/BusinessPage/BusinessPage';
import CertificatePage from './Pages/EntityPages/Certificates/CertificatePage/CertificatePage';
import CertificatesPage from './Pages/EntityPages/Certificates/CertificatesPage/CertificatesPage';
import CompetencePage from './Pages/EntityPages/Competences/CompetencePage/CompetencePage';
import CompetencesPage from './Pages/EntityPages/Competences/CompetencesPage/CompetencesPage';
import EmployeesPage from './Pages/EntityPages/Employees/EmployeesPage/EmployeesPage';
import EmployeeTalkPage from './Pages/EntityPages/EmployeeTalks/EmployeeTalkPage/EmployeeTalkPage';
import MvpEmployeeTalksPage from './Pages/EntityPages/EmployeeTalks/EmployeeTalksPage/MvpEmployeeTalksPage';
import OrgUnitPage from './Pages/EntityPages/OrgUnits/OrgUnitPage/OrgUnitPage';
import OrgUnitsPage from './Pages/EntityPages/OrgUnits/OrgUnitsPage/OrgUnitsPage';
import ProductPage from './Pages/EntityPages/Products/ProductPage/ProductPage';
import ProductsPage from './Pages/EntityPages/Products/ProductsPage/ProductsPage';
import ProjectPage from './Pages/EntityPages/Projects/ProjectPage/ProjectPage';
import ProjectsPage from './Pages/EntityPages/Projects/ProjectsPage/ProjectsPage';
import RolePage from './Pages/EntityPages/Roles/RolePage/RolePage';
import RolesPage from './Pages/EntityPages/Roles/RolesPage/RolesPage';
import SkillCategoriesPage from './Pages/EntityPages/SkillCategories/SkillCategoriesPage/SkillCategoriesPage';
import SkillCategoryPage from './Pages/EntityPages/SkillCategories/SkillCategoryPage/SkillCategoryPage';
import SkillPage from './Pages/EntityPages/Skills/SkillPage/SkillPage';
import SkillsPage from './Pages/EntityPages/Skills/SkillsPage/SkillsPage';

export default function RoutesComponent() {
    const secret = useSelector((state: AppState) => state.client.secret);
    const personas = useSelector((state: AppState) => state.personas);
    let secureRoutes;
    if (secret) {
        secureRoutes = (
            <React.Fragment>
                <Route index element={<MvpDashboardPage />} />
                <Route path={`${ELinks.LOGGEDIN}/*`} element={<LoggedInPage />} />

                <Route path={ELinks.EMAIL_SETTINGS} element={<EmailSettingsPage />} />

                <Route path={ELinks.DASHBOARD} element={<MvpDashboardPage />} />
                <Route path={`${ELinks.DASHBOARD}/:tab`} element={<MvpDashboardPage />} />
                <Route path={`${ELinks.DASHBOARD_EMPLOYEE}`} element={<MvpDashboardPage />} />
                {personas.includes(EPersona.FK) && (
                    <Route path={`${ELinks.DASHBOARD_MANAGER}`} element={<MvpDashboardPage />} />
                )}
                {personas.includes(EPersona.Admin) && (
                    <Route path={`${ELinks.DASHBOARD_ADMIN}`} element={<MvpDashboardPage />} />
                )}

                <Route path={ELinks.PROFILE} element={<MvpEmployeePage />} />
                <Route path={ELinks.PROFILE_SHOW} element={<MvpEmployeePage />} />
                <Route path={`${ELinks.PROFILE_SHOW}/:tab`} element={<MvpEmployeePage />} />

                <Route path={ELinks.PROFILE_EDIT} element={<ProfileSettings tabId={EProfileSettingsTabs.GENERAL} />} />
                <Route
                    path={ELinks.PROFILE_EDIT_ANALYSE}
                    element={<ProfileSettings tabId={EProfileSettingsTabs.ANALYSE} />}
                />
                <Route
                    path={ELinks.PROFILE_EDIT_FORECAST}
                    element={<ProfileSettings tabId={EProfileSettingsTabs.FORECAST} />}
                />
                <Route
                    path={ELinks.PROFILE_EDIT_ROLES}
                    element={<ProfileSettings tabId={EProfileSettingsTabs.ROLES} />}
                />
                <Route
                    path={ELinks.PROFILE_EDIT_SKILLS}
                    element={<ProfileSettings tabId={EProfileSettingsTabs.SKILLS} />}
                />
                <Route
                    path={ELinks.PROFILE_EDIT_SKILLS_SUGGESTIONS}
                    element={<ProfileSettings tabId={EProfileSettingsTabs.SKILLS} urlSuffix={'SUGGESTIONS'} />}
                />
                <Route
                    path={ELinks.PROFILE_EDIT_CERTIFICATES}
                    element={<ProfileSettings tabId={EProfileSettingsTabs.CERTIFICATES} />}
                />
                <Route
                    path={ELinks.PROFILE_EDIT_DEVELOPMENT}
                    element={<ProfileSettings tabId={EProfileSettingsTabs.DEVELOPMENT} />}
                />

                <Route path={ELinks.SETTINGS} element={<SettingsPage tabId={ESettingsTabs.GENERAL} />} />
                <Route path={ELinks.SETTINGS_STYLE} element={<SettingsPage tabId={ESettingsTabs.STYLE} />} />
                <Route path={ELinks.SETTINGS_LEVELS} element={<SettingsPage tabId={ESettingsTabs.LEVELS} />} />
                <Route
                    path={ELinks.SETTINGS_REGISTRATION}
                    element={<SettingsPage tabId={ESettingsTabs.REGISTRATION} />}
                />
                <Route path={ELinks.SETTINGS_ORGUNITS} element={<SettingsPage tabId={ESettingsTabs.ORGUNITS} />} />
                <Route
                    path={ELinks.SETTINGS_PERMISSIONS}
                    element={<SettingsPage tabId={ESettingsTabs.PERMISSIONS} />}
                />
                <Route path={ELinks.SETTINGS_TIME_SYNC} element={<SettingsPage tabId={ESettingsTabs.TIME_SYNC} />} />
                <Route path={ELinks.SETTINGS_HOLIDAYS} element={<SettingsPage tabId={ESettingsTabs.HOLIDAYS} />} />
                <Route
                    path={ELinks.SETTINGS_CALCULATIONS}
                    element={<SettingsPage tabId={ESettingsTabs.CALCULATIONS} />}
                />
                <Route path={ELinks.SETTINGS_EMAIL} element={<SettingsPage tabId={ESettingsTabs.EMAIL} />} />
                <Route
                    path={ELinks.SETTINGS_EMPLOYEE_TALK_TEMPLATE}
                    element={<SettingsPage tabId={ESettingsTabs.EMPLOYEE_TALK_TEMPLATE} />}
                />
                <Route path={ELinks.SETTINGS_TIME_SYNC} element={<SettingsPage tabId={ESettingsTabs.TIME_SYNC} />} />
                <Route path={ELinks.SETTINGS_MICROSOFT} element={<SettingsPage tabId={ESettingsTabs.MICROSOFT} />} />
                <Route path={ELinks.SETTINGS_RESTAPI} element={<SettingsPage tabId={ESettingsTabs.RESTAPI} />} />
                <Route
                    path={ELinks.SETTINGS_SUGGESTIONS}
                    element={<SettingsPage tabId={ESettingsTabs.SUGGESTIONS} />}
                />
                <Route path={ELinks.SETTINGS_SLACK} element={<SettingsPage tabId={ESettingsTabs.SLACK} />} />

                <Route path={ELinks.EMPLOYEE_TALKS} element={<MvpEmployeeTalksPage />} />
                <Route path={`${ELinks.EMPLOYEE_TALKS}/:id`} element={<EmployeeTalkPage />} />

                <Route path={ELinks.MESSAGES} element={<MessagesPage tabId={EMessageTabs.INBOX} />} />
                <Route path={`${ELinks.MESSAGES}/sent`} element={<MessagesPage tabId={EMessageTabs.SENT} />} />
                <Route path={`${ELinks.MESSAGES}/system`} element={<MessagesPage tabId={EMessageTabs.SYSTEM} />} />
                <Route path={`${ELinks.MESSAGES}/compose`} element={<MessagesPage tabId={EMessageTabs.COMPOSE} />} />

                <Route path={ELinks.COMPANY} element={<MvpCompanyLandingPage />} />

                <Route path={ELinks.MY_TEAM} element={<MyTeamLandingPage />} />
                <Route path={ELinks.MY_TEAM_MANAGE} element={<MyTeamPage />} />

                <Route path={ELinks.ROLES} element={<RolesPage />} />
                <Route path={`${ELinks.ROLES}/:id`} element={<RolePage />} />

                <Route path={ELinks.SKILLS} element={<SkillsPage />} />
                <Route path={`${ELinks.SKILLS}/:id`} element={<SkillPage />} />
                {/* <Route path={`${ELinks.SKILLS}/view/:tab`} element={<SkillsPage />} /> */}

                <Route path={`${ELinks.SKILLCATEGORIES}`} element={<SkillCategoriesPage />} />
                <Route path={`${ELinks.SKILLCATEGORIES}/:id`} element={<SkillCategoryPage />} />

                <Route path={ELinks.CERTIFICATES} element={<CertificatesPage />} />
                <Route path={`${ELinks.CERTIFICATES}/:id`} element={<CertificatePage />} />

                <Route path={ELinks.COMPETENCE} element={<CompetencesPage />} />
                <Route path={`${ELinks.COMPETENCE}/:id`} element={<CompetencePage />} />
                <Route path={`${ELinks.COMPETENCE}/:id/:tab`} element={<CompetencePage />} />

                <Route path={ELinks.SALES_PRODUCTS} element={<ProductsPage />} />
                <Route path={`${ELinks.SALES_PRODUCTS}/:id`} element={<ProductPage />} />
                <Route path={`${ELinks.SALES_PRODUCTS}/:id/:tab`} element={<ProductPage />} />

                <Route path={ELinks.PEOPLE} element={<PeopleOrgPage />} />
                <Route path={ELinks.PEOPLE_EMPLOYEES} element={<EmployeesPage />} />
                <Route path={`${ELinks.PEOPLE_EMPLOYEES}/:id`} element={<MvpEmployeePage />} />
                <Route path={`${ELinks.PEOPLE_EMPLOYEES}/:id/:tab`} element={<MvpEmployeePage />} />
                <Route path={ELinks.PEOPLE_ORGUNITS} element={<OrgUnitsPage />} />
                <Route path={`${ELinks.PEOPLE_ORGUNITS}/:id`} element={<OrgUnitPage />} />
                <Route path={`${ELinks.PEOPLE_ORGUNITS}/:id/:tab`} element={<OrgUnitPage />} />

                <Route path={ELinks.SALES} element={<SalesPage />} />
                {/* <Route path={`sales/opportunity/new`} element={<OpportunityPageNew />} /> */}
                <Route path={ELinks.SALES_OPPORTUNITIES} element={<LandingMvpOpportunity />} />
                <Route path="/sales/opportunities/list" element={<MvpOpportunitiesPage />} />
                <Route path={`${ELinks.SALES_OPPORTUNITIES}/:id`} element={<MvpOpportunityPage />} />
                <Route path={`${ELinks.SALES_OPPORTUNITIES}/:id/:tab`} element={<MvpOpportunityPage />} />

                <Route path={ELinks.SALES_PROJECTS} element={<ProjectsPage />} />
                <Route path={`${ELinks.SALES_PROJECTS}/:id`} element={<ProjectPage />} />

                <Route path={ELinks.SALES_CUSTOMERS} element={<BusinessesPage />} />
                <Route path={`${ELinks.SALES_CUSTOMERS}/:id`} element={<BusinessPage />} />

                <Route path={ELinks.DOCUMENTATION} element={<DocumentationPage />} />
                <Route path={ELinks.DOCUMENTATION_REST} element={<RestApiDocuPage />} />

                <Route path={ELinks.ONBOARDING} element={<OnboardingPage />} />

                <Route path={`*`} element={<NotFound />} />
            </React.Fragment>
        );
    }

    return (
        <Routes>
            <Route path={ELinks.LOGIN} element={<LoginPage />} />
            <Route path={`${ELinks.LOGGEDIN}/*`} element={<LoggedInPage />} />
            <Route path={ELinks.COMPANY_REGISTRATION} element={<CompanyRegistrationPage />} />
            <Route path={ELinks.EMAIL_UNSUBSCRIBE} element={<EmailUnsubscribePage />} />
            <Route path={ELinks.IMPRESSUM} element={<Impressum />} />
            <Route path={ELinks.KONTAKT} element={<Kontakt />} />
            <Route path={ELinks.DATENSCHUTZ} element={<Datenschutz />} />
            {secureRoutes}
            <Route path={`*`} element={<NotAllowed />} />
        </Routes>
    );
}
